<div class="order-details-skeleton">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
            <app-skeleton-rect width="120px" height="28px" class="mb-2 d-block"></app-skeleton-rect>
            <app-skeleton-rect width="150px" height="16px" class="d-block"></app-skeleton-rect>
        </div>
        <div class="d-flex align-items-center gap-2">
            <app-skeleton-rect width="24px" height="24px"></app-skeleton-rect>
            <app-skeleton-rect width="120px" height="16px"></app-skeleton-rect>
        </div>
    </div>

    <div class="row match-height">
        <!-- Main Content (Left) -->
        <div class="col-12 col-lg-8 col-xl-9">
            <!-- Products Table Card -->
            <div class="card mb-4">
                <div class="card-body">
                    <app-skeleton-rect width="100px" height="14px" class="mb-3 d-block"></app-skeleton-rect>

                    <!-- Table Header -->
                    <div class="table-header d-flex align-items-center py-2 px-2 mb-2">
                        <app-skeleton-rect width="150px" height="16px" class="me-auto"></app-skeleton-rect>
                        <app-skeleton-rect width="80px" height="16px" class="me-4"></app-skeleton-rect>
                        <app-skeleton-rect width="60px" height="16px" class="me-4"></app-skeleton-rect>
                        <app-skeleton-rect width="60px" height="16px" class="me-4"></app-skeleton-rect>
                        <app-skeleton-rect width="80px" height="16px"></app-skeleton-rect>
                    </div>

                    <!-- Table Rows -->
                    <ng-container *ngFor="let i of [0,1,2]">
                        <div class="table-row d-flex align-items-center py-3 px-2">
                            <div class="d-flex align-items-center me-auto" style="min-width: 200px;">
                                <app-skeleton-rect width="50px" height="50px" [borderRadius]="'8px'"
                                    class="me-3"></app-skeleton-rect>
                                <app-skeleton-rect width="150px" height="16px"></app-skeleton-rect>
                            </div>
                            <app-skeleton-rect width="70px" height="16px" class="me-4"></app-skeleton-rect>
                            <app-skeleton-rect width="60px" height="16px" class="me-4"></app-skeleton-rect>
                            <app-skeleton-rect width="40px" height="16px" class="me-4"></app-skeleton-rect>
                            <app-skeleton-rect width="70px" height="16px"></app-skeleton-rect>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- Billing Details Card -->
            <div class="card">
                <div class="card-header">
                    <app-skeleton-rect width="150px" height="20px"></app-skeleton-rect>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6 col-xl-4">
                            <div class="mb-2" *ngFor="let i of [0,1,2]">
                                <app-skeleton-rect width="80px" height="12px" class="mb-1 d-block"></app-skeleton-rect>
                                <app-skeleton-rect width="150px" height="14px" class="d-block"></app-skeleton-rect>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-xl-8">
                            <div class="mb-2" *ngFor="let i of [0,1,2]">
                                <app-skeleton-rect width="120px" height="12px" class="mb-1 d-block"></app-skeleton-rect>
                                <app-skeleton-rect width="200px" height="14px" class="d-block"></app-skeleton-rect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Sidebar (Right) -->
        <div class="col-12 col-lg-4 col-xl-3">
            <!-- Status Card -->
            <div class="card mb-4">
                <div class="card-body">
                    <app-skeleton-rect width="100px" height="14px" class="mb-2 d-block"></app-skeleton-rect>
                    <app-skeleton-rect width="100%" height="38px" class="mb-3 d-block"></app-skeleton-rect>
                    <app-skeleton-rect width="120px" height="14px" class="mb-3 d-block"></app-skeleton-rect>
                    <app-skeleton-rect width="100px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                </div>
            </div>

            <!-- Summary Card -->
            <div class="card">
                <div class="card-body">
                    <app-skeleton-rect width="100px" height="18px" class="mb-3 d-block"></app-skeleton-rect>
                    <div class="d-flex justify-content-between mb-2">
                        <app-skeleton-rect width="100px" height="14px"></app-skeleton-rect>
                        <app-skeleton-rect width="70px" height="14px"></app-skeleton-rect>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <app-skeleton-rect width="90px" height="14px"></app-skeleton-rect>
                        <app-skeleton-rect width="60px" height="14px"></app-skeleton-rect>
                    </div>
                    <div class="d-flex justify-content-between">
                        <app-skeleton-rect width="80px" height="14px"></app-skeleton-rect>
                        <app-skeleton-rect width="80px" height="16px"></app-skeleton-rect>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>